import { lazyLoad } from 'utils/loadable';

export const MixinitPage = lazyLoad(
  () => import('./index'),
  module => module.MixinitPage,
);
